<script>
  // Shared card grid wrapper — responsive grid layout that callers populate
  // with CardTile children. Keeping the layout in one place means search and
  // the update feed share identical breakpoints.
  //
  // Props:
  //   minTileWidth    {string}  — minmax floor at ≥769px (default '180px')
  //   minTileWidthMd  {string}  — minmax floor at ≤768px (default '130px')
  //   gap             {string}  — grid gap at ≥769px (default '20px')
  //   gapMd           {string}  — grid gap at ≤768px (default '12px')
  //   children        {Snippet} — the CardTile elements

  let {
    minTileWidth = '180px',
    minTileWidthMd = '130px',
    gap = '20px',
    gapMd = '12px',
    children,
  } = $props();
</script>

<div
  class="card-grid"
  style="
    --min-tile-width: {minTileWidth};
    --min-tile-width-md: {minTileWidthMd};
    --grid-gap: {gap};
    --grid-gap-md: {gapMd};
  "
>
  {@render children?.()}
</div>

<style>
  .card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--min-tile-width, 180px), 1fr));
    gap: var(--grid-gap, 20px);
  }

  @media (max-width: 768px) {
    .card-grid {
      grid-template-columns: repeat(auto-fill, minmax(var(--min-tile-width-md, 130px), 1fr));
      gap: var(--grid-gap-md, 12px);
    }
  }

  @media (max-width: 480px) {
    .card-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }
</style>
